export default __webpack_public_path__ + "static/media/rs_pdf_icon.78895c73.svg";